export var getConversationId = function (viewState) { return function () {
    return viewState.conversationId;
}; };
//# sourceMappingURL=ConversationIdAdapter.js.map